import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePaymentTerms() {
  const [terms, setTerms] = useState([]);
  useEffect(() => { api.get("/finance/payment-terms").then((r) => setTerms(r.data.data)).catch(() => setTerms([])); }, []);
  return terms;
}

export const findTerm = (terms, id) => terms.find((t) => t.odoo_id === id) || null;

export const termText = (t) => (t ? `${t.name}${t.lines?.some((l) => l.delay_type && l.delay_type !== "days_after") ? "" : ` (${t.days || 0} hari)`}` : "");

export function TermSelect({ terms, value, onChange, placeholder, testId }) {
  return (
    <select className="rj-select" value={value ?? ""} onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)} data-testid={testId}>
      <option value="">{placeholder}</option>
      {terms.map((t) => <option key={t.odoo_id} value={t.odoo_id}>{termText(t)}</option>)}
    </select>
  );
}

// Hint explaining what happens with the chosen AR Term.
export function TermHint({ row, termId, terms, testId }) {
  if (!row.customer_in_app) return termId ? <small className="term-hint manual" data-testid={testId}>AR Term dipakai untuk invoice ini. Jika customer belum punya AR Term di Odoo, pilihan ini juga disimpan ke customer di Odoo.</small> : null;
  if (!row.ar_term_odoo_id) {
    return <small className="term-hint warn" data-testid={testId}>Customer belum punya AR Term{termId ? ` — "${findTerm(terms, termId)?.name}" akan disimpan ke customer (Sales Hub & Odoo).` : ". Pilih AR Term agar tersimpan ke customer, atau biarkan Immediate."}</small>;
  }
  if (termId && termId !== row.ar_term_odoo_id) {
    return <small className="term-hint manual" data-testid={testId}>AR Term manual hanya untuk invoice ini. AR Term customer tetap "{row.ar_term_name}".</small>;
  }
  return null;
}
